module.exports = __webpack_public_path__ + "img/go.b74bfcb2.svg";